module.exports = __webpack_public_path__ + "static/media/products_Selected.bb4591f3.svg";